import type { LevelDef } from '../../content/levelSchema';
import { hashString32 } from '../../sim/rng';
import { customLevel, type CustomLawn } from '../customLawns';
import { decodeLawn } from '../lawnCode';

/**
 * A community lawn as everyone plays it (docs/ONLINE.md, "Community lawns"): decoded from its code,
 * with an id made from the code itself, so the lawn (and anything seeded by its id) is the same on
 * every phone and in the server's run check. Null when this game cannot read the code.
 */
export function communityLawn(code: string): CustomLawn | null {
  const decoded = decodeLawn(code);
  return decoded.ok ? { ...decoded.lawn, id: `my-${hashString32(code)}` } : null;
}

/** The community lawn's level, or null when this game cannot read its code. */
export function communityLevel(code: string): LevelDef | null {
  const lawn = communityLawn(code);
  return lawn ? customLevel(lawn) : null;
}
